import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    regionName: string;
    selectionName: string;
    action: "on" | "off";
    eventName?: string;
    openFromLabel?: string | null;
}

export function hitMapCheckboxToggle(params: IHitMapSearchParams) {
    const {regionName, selectionName, action, eventName, openFromLabel} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: "checkbox",
        event_category: regionName,
        event_category2: selectionName,
        event_label: action,
        ...(openFromLabel ? {custom_label: openFromLabel} : {})
    });
}
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHitMapSearchParams {
    regionName: string;
    selectionName: string;
    action: "on" | "off";
    eventName?: string;
    openFromLabel?: string | null;
}

export function hitMapCheckboxToggle(params: IHitMapSearchParams) {
    const {regionName, selectionName, action, eventName, openFromLabel} = params;

    hitGoogleTagManager({
        event: eventName || "map_search",
        event_action: "checkbox",
        event_category: regionName,
        event_category2: selectionName,
        event_label: action,
        ...(openFromLabel ? {custom_label: openFromLabel} : {})
    });
}
